







































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import {
  INTRASEQ_ANTIBODY_COCKTAIL_TEMPLATE,
  INTRASEQ_ASSAY_KIT_TEMPLATE,
  INTRASEQ_CONJUGATE_TEMPLATE,
} from '@/common/utils/product/constants'
import { useFeatureFlag } from '~/composables/featureFlags/useFeatureFlag'
import { useI18n } from '~/composables/i18n'

export default defineComponent({
  props: {
    templateTitle: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const newSearchUrlStructure = useFeatureFlag('newSearchUrlStructure')
    const { t } = useI18n()
    const displayCondition = ref(
      [INTRASEQ_ANTIBODY_COCKTAIL_TEMPLATE, INTRASEQ_ASSAY_KIT_TEMPLATE, INTRASEQ_CONJUGATE_TEMPLATE].includes(
        props.templateTitle
      )
    )

    const individualConjugatesUrl = computed(() => {
      if (newSearchUrlStructure.value) {
        return '/browse?product-category=intraseq-kits-and-reagents&product-type=monoclonal-antibody&noscroll=1'
      }

      const oldParams = new URLSearchParams({
        tab: 'product',
        categories: 'InTraSeq&#8482; Kits & Reagents',
        producttype: 'Monoclonal Antibody',
        noscroll: '1',
      })

      return `/browse?${oldParams.toString()}`
    })

    return {
      INTRASEQ_ASSAY_KIT_TEMPLATE,
      INTRASEQ_ANTIBODY_COCKTAIL_TEMPLATE,
      INTRASEQ_CONJUGATE_TEMPLATE,
      individualConjugatesUrl,
      displayCondition,
      t,
    }
  },
})
